/**
 * A no-op function that does nothing.
 */
export function noop(): void {
  // no-op
}
